// @flow

type CommonError = 'runtime-error' | 'api-error' | 'promise-error';
type FullStoryEvent =
  | 'multiple-drag-drop-success'
  | 'hide-empty-folder'
  | 'reorder-start'
  | 'reorder-submit'
  | 'reorder-cancel'
  | 'redaction-ai-pattern-used'
  | 'redaction-ai-patterns-not-ready';

const logger = {
  error(error: Error, errorType: CommonError = 'runtime-error') {
    if (window.newrelic) {
      let usefulErrorMsg = error;

      if (error && error.stack) {
        usefulErrorMsg = error.stack;
      }

      window.newrelic.noticeError(usefulErrorMsg, {
        area: 'spa',
        errorType,
      });
    } else {
      // eslint-disable-next-line no-console
    }
  },
  fullStoryEvent(eventName: FullStoryEvent, attributes: Object = {}) {
    if (typeof FS !== 'undefined' && FS && FS.event) {
      FS.event(eventName, attributes);
    }
  },
};

export default logger;
export type { FullStoryEvent };
